;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	Backbone.Form.editors.CheckboxCustom = Backbone.Form.editors.Checkbox.extend({
		template: _.template('<div class="input-append">' +
			'<input type="checkbox" id="<%= id %>" name="<%= key %>" />' +
			'<label for="<%= id %>"><%= title %></label>' +
			'</div>', null, Backbone.Form.templateSettings),
		events: {
			'change': function(value) {
				this.setValue(this.getValue());
				this.trigger('change', this);
			},
			'focus': function() {
				this.trigger('focus', this);
			},
			'blur': function() {
				this.trigger('blur', this);
			}
		},
		initialize: function(options) {
			Backbone.Form.editors.Base.prototype.initialize.call(this, options);
			this.value_in_model = options.model.get(options.key);
		},
		getValue: function() {
			var inputVal = $(this.$el).find('input').prop('checked');
			inputVal = inputVal ? 1 : 0;
			return inputVal;
		},
		setValue: function(value) {
			if (value !== this.previousValue){
				this.previousValue = value;
			}
			return this.$el.val(value);
		},
		render: function(options) {
			Backbone.Form.editors.Base.prototype.render.apply(this, arguments);
			var $el = $($.trim(this.template({
				id: this.id,
				key: this.key,
				title: this.schema.title
			})));
			$($el).find('input').prop("checked", this.value_in_model);
			this.setElement($el);
			return this;
		}
	});


}(window, APP, Backbone, Marionette, $, _));
